<template>
<div id="findpw">
    <div id="main">
        <div id="wrap join-wrap" style="overflow: scroll;">
            <div id="header">
                <div class="header-wrap">
                    <div class="top-menu-bar">
                        <div class="back" @click="go_login()">
                            <a href="#">
                                <img src="../../assets/images/back.png" alt="icon-menu">
                            </a>
                        </div>
                        <h1 class="page-title">
                            <a>
                                <span>ID/PW 찾기</span>
                            </a>
                        </h1>
                        <!-- <div class="mypage">
                            <a href="#">

                            </a>
                        </div> -->
                        <div class="bottom-radius"></div>
                    </div>
                </div>
            </div>
            <div id="join">
                <div class="input-join">

                    <div class="join-content">
                        <h3 class="join-title"><label for="user_hp">휴대폰번호</label></h3>
                        <div>
                            <input type="text" name="user_hp" v-on:input="autoHyphen" placeholder="휴대폰번호" v-bind:value="user_hp" :readonly="auth_flag">
                            <div class="btn-ok btn-confirm"  @click="next_step"><span>인증번호 요청</span></div>
                        </div>
                        <!-- 2021-01-14 코드수정 및 추가 -->
                        <p v-if="status_hp == false" class="warn-text" style="color:red">휴대전화번호 10자리 또는 11자리를 정확히 입력해주세요.</p>
                    </div>

                    <div class="join-content" v-if="auth_step">
                        <h3 class="join-title"><label for="user_hp">인증번호</label></h3>
                        <div>
                            <input type="text" id="auth_num" name="auth_num" v-model="auth_num">
                            <div class="btn-ok btn-confirm"  @click="auth_chk" v-if="auth_num.length > 0"><span>인증번호 확인</span></div>
                            <div class="btn-noauth btn-confirm"  v-if="auth_num.length == 0"><span>인증번호 확인</span></div>
                        </div>
                        <p v-if="auth_flag == false" class="warn-text" style="color:red">{{ authErrorMessage }}</p>
                    </div>

                     <div class="join-content" v-if="auth_flag == true">
                        <h3 class="join-title"><label for="user_hp">아이디</label></h3>
                        <div>
                            <input type="text" name="user_hp" v-on:input="autoHyphen" placeholder="아이디" v-bind:value="user_m_account_id" :readonly="true">
                            <div class="btn-ok btn-confirm"  @click="change_pw_open"><span>비밀번호 변경</span></div>
                        </div>
                        <!-- 2021-01-14 코드수정 및 추가 -->
                        <p v-if="status_hp == false" class="warn-text" style="color:red">휴대전화번호 10자리 또는 11자리를 정확히 입력해주세요.</p>
                    </div>

                    <div class="join-content" v-if="change_pw_check == true">
                        <h3 class="join-title"><label for="user_password">비밀번호<span style="color:red">*</span></label></h3>
                        <input type="password" id="user_password" name="user_password" v-model="password">
                        <!-- 2021-01-14 코드수정 및 추가 -->
                        <p v-if="password.length < 8" class="warn-text" style="color:red">비밀번호 8자리이상 영문+숫자</p>
                    </div>
                    <div class="join-content" v-if="change_pw_check == true">
                        <h3 class="join-title"><label for="password_confirm">비밀번호 확인<span style="color:red">*</span></label></h3>
                        <input type="password" id="password_confirm" name="password_confirm" v-model="password_chk">
                        <p v-if="password != password_chk" class="warn-text" style="color:red">비밀번호가 일치하지 않습니다.</p>
                    </div>

                </div>
                <div class="btn-wrap btn-form-join" v-if="change_pw_check == true">
                    <div class="btn-noauth btn-join" @click="change_pw"><span>변경하기</span></div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config'
import common from '../../js/common'
import EventBus from '../../js/event_bus'
export default {
  name: 'findpw',
  components: {},
  data () {
    return {
      user_hp: '010',
      password: '',
      password_chk: '',
      auth_step: false,
      auth_num: '',
      auth_flag: false,
      status_hp: null,
      auth_check: false,
      authErrorMessage: '',
      m_user_id: '',
      user_m_account_id: '',
      change_pw_check: false
    }
  },
  mounted () {
    this.$nextTick(function () {

    })
  },
  methods: {
    go_login () {
      this.$router.push('/login')
    },
    autoHyphen (e) {
      this.user_hp = e.target.value
      var num = /^[0-9 \-]*$/
      if (!num.test(this.user_hp)) {
        var str = this.user_hp
        str = str.substr(0, str.length - 1)
        this.user_hp = str
      }

      if (this.user_hp.length > 13) {
        this.user_hp = this.user_hp.substr(0, 13)
      } else {
        var val = this.user_hp.replace(/\D/g, '')
        var original = this.user_hp.replace(/\D/g, '').length
        var conversion = ''
        for (let i = 0; i < 3; i++) {
          if (val.length > 3 && i === 0) {
            conversion += val.substr(0, 3) + '-'
            val = val.substr(3)
          } else if (original > 6 && val.length > 3 && i === 1) {
            conversion += val.substr(0, 3) + '-'
            val = val.substr(3)
          } else if (original > 10 && val.length < 12 && i === 2) {
            let value = this.user_hp.replace(/-/gi, '')
            conversion = ''
            this.user_hp = value.substring(0, 3) + '-' + value.substring(3, 7) + '-' + value.substring(7, 11)
            return this.user_hp
          }
        }
        conversion += val
        this.user_hp = conversion
      }
    },
    next_step () {
      this.auth_num = ''
      this.auth_flag = false
      // 2021-01-14 코드수정 및 추가
      if (this.user_hp.length < 12) {
        this.status_hp = false
        return
      }

      var data = {
        user_hp: this.user_hp,
        store_tel_number: '1811-8684',
        store_id: 'join_msg'
      }
      var type = config.REQ_AUTH
      common.getData(type, data,
        (response) => {
          if (response.result) {
            var data = {
              code: 103,
              message: '입력하신 번호로 인증번호를 전송했습니다. <br> 5분 이내에 인증번호를 입력해주세요.'
            }
            EventBus.$emit('popup-data', data)
            this.status_hp = true
            this.auth_step = true
          }
        })
    },
    auth_chk () {
      if (this.auth_flag === true) {
        return
      }
      var data = {
        auth_num: this.auth_num,
        user_hp: this.user_hp
      }
      let popData = {
        code: 103,
        message: ''
      }

      var type = config.REQ_CHECK_AUTH
      common.getData(type, data,
        (response) => {
          if (response.result) {
            this.m_user_id = response.data[0].m_user_id
            this.user_m_account_id = response.data[0].user_m_account_id
            if (!this.m_user_id) {
              this.auth_flag = false
              popData.message = '아이디가 없습니다.'
            } else {
              this.auth_flag = true
              popData.message = '인증되었습니다.'
            }
            EventBus.$emit('popup-data', popData)
          } else {
            if (response.result_txt === 'time_over') {
              var data = {
                user_hp: this.user_hp,
                m_auth_use_id: response.m_auth_use_id
              }
              var type = config.REQ_RE_AUTH
              common.getData(type, data,
                (response) => {
                  if (response.result) {
                    popData.message = '시간이 경과되었습니다.<br> 입력하신 번호로 인증번호를 재전송했습니다. <br> 5분 이내에 인증번호를 입력해주세요.'

                    EventBus.$emit('popup-data', popData)

                    this.auth_num = ''
                  }
                })
            } else if (response.result_txt === 'number_err') {
              popData.message = '인증번호가 올바르지 않습니다.'
              EventBus.$emit('popup-data', popData)
            }
            this.auth_flag = false
          }
          this.authErrorMessage = popData.message
        })
    },
    change_pw_open () {
      this.change_pw_check = true
    },
    change_pw () {
      if (this.password !== this.password_chk) {
        var data = {
          code: 103,
          message: '비밀번호가 서로 일치하지 않습니다.'
        }
        EventBus.$emit('popup-data', data)
        return
      }
      if (this.password.length == 0 || this.password_chk.length == 0) {
        var data = {
          code: 103,
          message: '비밀번호를 정확히 입력해주세요.'
        }
        EventBus.$emit('popup-data', data)
        return
      }
      var user_info = this.$store.getters['getUser_info']

      var data = {
        password: this.password,
        m_user_id: this.m_user_id
      }
      var type = config.REQ_PASS_EDIT
      common.getData(type, data,
        (response) => {
          console.log(response)
          if (response.result) {
            // 팝업
            var data = {
              code: 103,
              message: '비밀번호가 변경되었습니다.'
            }
            EventBus.$emit('popup-data', data)
            this.$router.push('/login')
          }
        })
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/page/FindPwPage.vue